<template>
  <form @submit.prevent="submit" class="container mt-lg-5 mb-5 d-flex flex-column gap-3 w-100">
    <!-- Campos del Formulario -->
    <h2 for="nombreFormulario">{{ form.NombreFormulario }}</h2>

    <p class="w-100" style="white-space: pre-wrap;  word-wrap: break-word;">{{ form.Descripcion }}</p>
    
    <div v-if="form.Observacions.some(p => p.Obligatorio)" class="d-flex flex-row gap-1">
      <div class="ps-1 border border-warning fondo-principal rounded text-danger" style="width: 16.5px; height: 17px;">*</div>
      <p class="text-wrap text-body-tertiary fs-7 w-100 m-0">{{ $t('obsObligatoria') }}</p>
    </div>
    <div v-if="form.Anonimo" class="d-flex flex-row gap-1">
      <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
        <path stroke="#9fa0a2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 0 .211-.106a4 4 0 0 1 3.578 0L14 7.5m0 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Zm-2 6.303c5-3 5 3.5 9 1.767-1 4.233-6 4.233-9 1.233-3 3-8 3-9-1.233 4 1.733 4-4.767 9-1.767Z"/>
      </svg>
      <p class="text-wrap text-body-tertiary fs-7 w-100 m-0">{{ $t('formAnonimo') }}</p>
    </div>

    <!-- Divider -->
    <div class="col-12 my-2" style="border-top: 1px solid #ddd; height: 1px"></div>


    <div class="d-flex flex-column gap-3 w-100">
      <!-- Observaciones -->
      <div v-for="(observacion, indexObs) in form.Observacions.filter(observacion => !observacion.Oculta || observacion.ItemsObservacions.some(item => item.IdPersona == this.user.idPersona))" :key="indexObs" class="p-3 border fondo-secundario rounded" :class="{ 'border-warning': observacion.Obligatorio, 'borde-terciario': !observacion.Obligatorio  }">
        <!-- <div v-if="!observacion.Oculta || observacion.ItemsObservacions.some(item => item.IdPersona == user.idPersona)"> -->
          <div class="mb-0 d-flex flex-row gap-2 justify-contents-center align-items-center">
            <h4 id="exampleTextarea" style="">{{ observacion.NombreObservacion }} <span v-if="observacion.Obligatorio" class="text-danger">*</span></h4>
          </div>
          
          <p class="w-100" style="white-space: pre-wrap;  word-wrap: break-word;">{{ observacion.Descripcion }}</p>

          <!-- Mostrar campos diferentes según el tipo de observación -->
          <div v-if="observacion.IdTipoObservacion === '6A89FB8F-18B7-45B7-8015-AB1445BBAD4A'.toLowerCase()"><!--Texto Corto-->
            <div class="w-100 p-3 fondo-terciario sombra-sm rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>

            <textarea
              class="form-control"
              id="exampleTextarea"
              placeholder="Texto corto"
              rows="1"
              oninput="this.style.height = ''; this.style.height = this.scrollHeight + 2 + 'px'"
              style="height: 38px; resize: none;"
              v-model="formRespuestas.Observacions[indexObs].Valores[0].ValorObservado"
              :required="observacion.Obligatorio"
              maxlength="200"
            ></textarea>
          </div>

          <div v-if="observacion.IdTipoObservacion === '9d19533b-3d29-4ff3-9be4-0ec902db6191'.toLowerCase()"><!--Fecha-->
            <div class="w-100 p-3 fondo-terciario sombra-sm rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>

            <input type="date" class="form-control" id="fecha" :placeholder="$t('seleccionaFecha')+'...'" v-model="formRespuestas.Observacions[indexObs].Valores[0].ValorObservado" :required="observacion.Obligatorio">
          </div>

          <div v-if="observacion.IdTipoObservacion === '56cdebd4-89e8-4bb2-a26e-8f366c3f4159'.toLowerCase()"><!--Hora-->
            <div class="w-100 p-3 fondo-terciario sombra-sm rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>

            <input type="time" class="form-control" id="hora" :placeholder="$t('seleccionaHora')+'...'" v-model="formRespuestas.Observacions[indexObs].Valores[0].ValorObservado" :required="observacion.Obligatorio">
          </div>

          <div v-if="observacion.IdTipoObservacion === '4BA48D01-AFEB-4D81-87D2-67FA07187CB5'.toLowerCase()" class="d-flex flex-column gap-1"><!--Opciones-->
            <div class="w-100 p-3 fondo-terciario sombra-sm rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>

            <!-- Items de Observación -->
            <label v-for="(item, indexItem) in observacion.ItemsObservacions" :key="indexItem" class="d-flex flex-row m-0 ms-1 align-items-center gap-2">
              <input class="form-check-input" type="radio" :name="'observacion_' + indexObs" v-model="formRespuestas.Observacions[indexObs].Valores[0].ValorObservado" :value="item.NombreItem" :required="observacion.Obligatorio"/>
              {{ item.NombreItem }}
            </label>
          </div>

          <div v-if="observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()" class="d-flex flex-column gap-2"><!--Rango-->
            <div class="w-100 p-3 fondo-terciario sombra-sm rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>

            <span>{{ observacion.Valores[0].ValorObservado }}</span>
            
            <div class="d-flex justify-content-between gap-2">
              <!-- Valor mínimo -->
              <span>{{ minRange }}</span>
              
              <!-- Slider de rango -->
              <input 
                type="range" 
                class="form-range" 
                :min="minRange" 
                :max="maxRange" 
                :step="stepValue" 
                id="customRange3"
                v-model="formRespuestas.Observacions[indexObs].Valores[0].ValorObservado" 
                :required="observacion.Obligatorio"
              />
              
              <!-- Valor máximo -->
              <span>{{ maxRange }}</span>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === 'B3903AB7-FC85-45C3-AD59-7943330DB389'.toLowerCase()" class="d-flex flex-column gap-4"><!--Numero-->
            <div class="w-100 p-3 fondo-terciario sombra-sm rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
            <div class="input-group mb-3">
              <span class="p-2 rounded-start-2 sombra-sm fondo-terciario texto-principal border-end border-2 borde-principal" id="basic-addon1">Valor</span>
              <input class="form-control sombra-sm" type="number" v-model="observacion.Valores[0].ValorObservado" style="max-width: 100px;" :required="observacion.Obligatorio"/>
            </div>
          </div>

          <div v-if="observacion.IdTipoObservacion === 'e42de6bc-9113-4ba6-8818-49fa8a2c0c6f'.toLowerCase()">
            <div class="w-100 p-3 fondo-terciario sombra-sm rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ $t(observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '') }}</p>
            </div>
            <div class="btn-group w-100 sombra-sm bg-goethe-accent-claro-3" role="group" aria-label="Basic radio toggle button group" style="height: 50px;">

              <input type="radio" class="btn-check" :name="'observacion_' + indexObs" :id="'btnradio1_' + indexObs"  autocomplete="off" v-model="formRespuestas.Observacions[indexObs].Valores[0].ValorObservado" :value="'Si'" :required="observacion.Obligatorio">
              <label class="btn border-end border-start d-flex align-items-center justify-content-center border-goethe-accent-claro texto-principal" :for="'btnradio1_' + indexObs">{{ $t('Si') }}</label>

              <input type="radio" class="btn-check" :name="'observacion_' + indexObs" :id="'btnradio2_' + indexObs"  autocomplete="off" v-model="formRespuestas.Observacions[indexObs].Valores[0].ValorObservado" :value="'No'">
              <label class="btn border-end border-start d-flex align-items-center justify-content-center border-goethe-accent-claro texto-principal" :for="'btnradio2_' + indexObs">{{ $t('No') }}</label>

              <input type="radio" class="btn-check" :name="'observacion_' + indexObs" :id="'btnradio3_' + indexObs"  autocomplete="off" v-model="formRespuestas.Observacions[indexObs].Valores[0].ValorObservado" :value="'No Observable'">
              <label class="btn border-end border-start d-flex align-items-center justify-content-center border-goethe-accent-claro texto-principal" :for="'btnradio3_' + indexObs">{{ $t('No Observable') }}</label>

            </div>
          </div>


            
          <div v-if="observacion.IdTipoObservacion === 'bb1c6568-f8ea-42bc-9133-375f86fa2415'.toLowerCase()"><!--Archivo-->
            <div class="w-100 p-3 fondo-terciario sombra-sm rounded mb-3">
              <p class="text-wrap fs-6 w-100 m-0"><span class="fw-bold">{{ $t('valorIngresado') }}:</span> {{ observacion.Valores[0]?.ValorObservado.toLowerCase() ? observacion.Valores[0].ValorObservado.toLowerCase() : '' }}</p>
            </div>
            
            <label>{{ $t('subirArchivo') }}</label>
            <input 
              type="file" 
              class="form-control" 
              @change="handleFileUpload($event, indexObs)" 
              :id="'archivo-' + indexObs" 
              accept=".pdf,.doc,.docx,.jpg,.png,.txt,.zip"
              :required="observacion.Obligatorio"
            />
            <small class="text-muted">{{ $t('tamanoMaximo') }}: 50MB</small>
          </div>

          <!----------------------- Este codigo esta inhabilitado ---------------------->
          <div v-if="observacion.IdTipoObservacion === '989bec4b-779d-41b0-8b28-1f1487b59ded'.toLowerCase() & false" class="d-flex flex-column gap-2 w-100"><!--Evaluado-->
              <!-- Eleccion de CursoGrupoAulaEspacio -->
            <div v-if="observacion.TipoEvaluado == 'Curso o Grupo'">
              <input type="text" v-model="searchQueryCursosGrupos" :placeholder="$t('buscar')+'...'" class="form-control mb-2" @input="filterCursosGrupos" required/>
              <ul v-if="filteredCursosGrupos.length > 0" class="list-group position-absolute" style="z-index: 1000; width: 100%;">
                <li v-for="cursoGrupo in filteredCursosGrupos"  :key="cursoGrupo.idCursoGrupo"  class="list-group-item list-group-item-action" @click="selectCursoGrupo(cursoGrupo)" style="cursor: pointer;">
                  {{ cursoGrupo.CursoGrupo }}
                </li>
              </ul>
              
              <div v-if="loadingCursosGrupos" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
              </div>
            </div>

            <!-- Eleccion de Persona -->
            <div v-if="observacion.TipoEvaluado == 'Profesor' || observacion.TipoEvaluado == 'Alumno' || observacion.TipoEvaluado == 'Familia'">
              <input type="text" v-model="formRespuestas.Observacions[indexObs].SearchQuery" :placeholder="$t('buscarPersona')+'...'" class="form-control mb-2" @input="filterPersonas(formRespuestas.Observacions[indexObs])" required/>
              <ul v-if="formRespuestas.Observacions[indexObs].FilteredPersonas.length > 0" class="list-group position-absolute" style="z-index: 1000; width: 100%;">
                <li v-for="evaluado in formRespuestas.Observacions[indexObs].FilteredPersonas"  :key="evaluado.IdPersona"  class="list-group-item list-group-item-action" @click="selectPersona(evaluado, formRespuestas.Observacions[indexObs])" style="cursor: pointer;">
                  {{ evaluado?.Apellido + ' ' + evaluado?.Nombre }}
                </li>
              </ul>
              
              <div v-if="loadingPersonas" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
              </div>
            </div>
            

            <div v-if="formRespuestas.Observacions[indexObs].ConEleccionMateria">
              <label>{{ $t('materia') }}:</label>
              <select v-model="selectedAsignaturaId" style="width: 100%;" class="form-select" required>
                <option v-for="asignatura in asignaturas" :key="asignatura.IdAsignatura" :value="asignatura.IdAsignatura">
                  {{ asignatura.NombreInterno + ' ' + asignatura.IdCursoGrupoNavigation.CursoGrupo}}
                </option>
              </select>
              <div v-if="loadingMaterias" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
              </div>
            </div>

            <div v-if="formRespuestas.Observacions[indexObs].TipoEvaluado == 'Personalizado'">
              <input type="text" v-model="formRespuestas.Observacions[indexObs].SearchQuery" :placeholder="$t('buscarPersona')+'...'" class="form-control mb-2" @input="filterPersonas(formRespuestas.Observacions[indexObs])" required/>
              <ul v-if="formRespuestas.Observacions[indexObs].FilteredPersonas.length > 0" class="list-group position-absolute" style="z-index: 1000; width: 100%;">
                <li v-for="evaluado in formRespuestas.Observacions[indexObs].FilteredPersonas"  :key="evaluado.IdPersona"  class="list-group-item list-group-item-action" @click="selectPersona(evaluado, formRespuestas.Observacions[indexObs])" style="cursor: pointer;">
                  {{ evaluado?.Apellido + ' ' + evaluado?.Nombre }}
                </li>
              </ul>
            </div>
          </div>

          <div v-if="formRespuestas.Observacions[indexObs].conComentario" class="position-relative" style="width: 100%;">
            <label for="descripcion">{{ $t('comentario') }}</label>
            <textarea id="descripcion" v-model="formRespuestas.Observacions[indexObs].Valores[0].Comentario" class="form-control" style="height: 120px; resize: none;" maxlength="500" :required="formRespuestas.Observacions[indexObs].Obligatorio"></textarea>

            <div class="mt-2 text-end">
              <span>{{ formRespuestas.Observacions[indexObs].Valores[0]?.Comentario.length || 0 }}/500 {{ $t('caracteres') }}</span> <!-- Actualiza el número según tu límite -->
            </div>
          </div>
      </div>

      <div v-if="loadingForm" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
        <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
      </div>
      <div class="d-flex gap-2">
        <button type="submit" class="btn btn-success">{{ $t('enviar') }}</button>
        <button class="btn btn-danger" @click="cancelForm">{{ $t('cancelar') }}</button>
        <div v-if="loadingSubmit" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { ref, computed, onMounted, onBeforeMount, toRaw } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const form = ref({
      Descripcion: '',
      TituloEleccionEvaluado: '',
      ConEleccionEvaluado: false,
      TipoEvaluado: '',
      ConEleccionMateria: false,
      NivelMateria: '',
      FechaCreacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      FechaModificacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      IdCreador: null,
      IdFormulario: null,
      NombreFormulario: '',
      ConAccesoRestringido : false,
      AccesoFormulario: [],
      Observacions: [], // Array de objetos para observaciones
    });

    
    const formValoresDeEvaluado = ref({
      Observacions: [], // Array de objetos para observaciones
    });

    const formRespuestas = ref({
      Observacions: [], // Array de objetos para observaciones
    });
    
    const persona = ref([]);
    const selectedPersona = ref(null); // Persona seleccionada
    const selectedAsignaturaId = ref(null); // Asignatura seleccionada
    const loadingPersonas = ref(false);
    const loadingCursosGrupos = ref(false);
    const loadingMaterias = ref(false);
    const loadingForm = ref(false);
    const loadingSubmit = ref(false);
    
    let evaluados = ref([]);
    let searchQuery = ref('');
    let filteredevaluados = ref([]);
    let selectedevaluados = ref(null);

    let ValorEvaluado = ref({});

    let asignaturas = ref([]);
    let cursosGrupos = ref([]);
    const searchQueryCursosGrupos = ref('');
    const filteredCursosGrupos = ref([]);
    const selectedCursosGrupos = ref(null);

    const minRange = ref(1);
    const maxRange = ref(5);
    const stepValue = ref(0.5);

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        if(form.value.ConAccesoRestringido){
          console.log(user?.value.idPersona)
          if((form.value.AccesoFormularios.some(accesoForm => accesoForm.IdPersona === user?.value.idPersona)) || (form.value.IdCreador == user?.value.idPersona)){
            console.log("Tiene Permiso de Completar")
          }
          else{
            console.log('Usuario no tiene permiso a acceder.');
            alert('No tienes permiso para completar este formulario')
            localStorage.removeItem('redirectAfterLogin');
            await router.push('/');
          }
        }
        else{
          console.log("Usuario Autenticado"+form.value.ConAccesoRestringido)
        }
      }
    };


    const fetchForm = async () => {
      try {
        loadingForm.value = true;
        const idForm = localStorage.getItem('idForm');
        const response = await api.get(`api/Formularios/ByIdBasicoAndAccesos`, {
            params: {
                id: idForm
            },
        });
        let TempForm = response.data;
        // Add the additional properties to each observation
        if (TempForm && Array.isArray(TempForm.Observacions)) {
          TempForm.Observacions.forEach(obs => {
            if(obs.TipoEvaluado == "Personalizado"){
              obs.PersonasSeleccionadas = obs.ItemsObservacions.map(item => item.IdPersonaNavigation);
              obs.AgregarPersona = false;
              obs.FilteredPersonas = [];
              obs.SearchQuery = '';
            } else {
              obs.PersonasSeleccionadas = [];
              obs.AgregarPersona = false;
              obs.FilteredPersonas = [];
              obs.SearchQuery = '';
            }
          });
        }
        if(TempForm.IdCreador == user?.value.idPersona || TempForm.AccesoFormularios.find(acceso => (acceso.IdPersona === user?.value.idPersona || acceso.IdOpcionGrupoNavigation?.PersonasRelacionadas?.some(pr => pr.IdPersona == user?.value.idPersona)) && (acceso.TipoPermiso == "Respondedor" || acceso.TipoPermiso == "Editor"))){
          console.log('Tiene permisos de edicion')
        } else{
          const accesoCompletador = TempForm.AccesoFormularios.find(acceso => (acceso.IdPersona === user?.value.idPersona || acceso.IdOpcionGrupoNavigation?.PersonasRelacionadas?.some(pr => pr.IdPersona == user?.value.idPersona)) && acceso.TipoPermiso == "Completador" );
          if (accesoCompletador) {
            await router.push('/formularios/completar');
          }
          else{
            await router.push('/formularios');
          }
        }

        console.log(TempForm)
        const idSubmit = localStorage.getItem('idSubmit');
        localStorage.removeItem('idSubmit');
        let response2 = await api.get(`api/Valores/ByIdSubmit`, {
          params: {
            id: idSubmit
          },
        });


        console.log(response2.data)
        TempForm.Observacions.forEach((observacion) => {
            observacion.IsChartInProgress = false;
            // Aquí es donde se agregan los valores correspondientes de la respuesta
            const valorEncontrado = response2.data.Valores.find(o => o.IdObservacion === observacion.IdObservacion);
            if (valorEncontrado) {
              valorEncontrado.observacion = {
                  ...observacion,
                  Valores: []  // Podés vaciarlo sin afectar el original
                };
              // Clonamos el objeto para no modificar el original
              const observacionValor = JSON.parse(JSON.stringify(valorEncontrado));
              
              observacionValor.Submit = {
                ...submit,
                Valores: []  // Podés vaciarlo sin afectar el original
              };
              observacion.Valores.push(observacionValor);
            }
        });
        form.value = TempForm
        console.log(form.value)
        loadingForm.value = false;
        addValor();
      } catch (error) {
        loadingForm.value = false;
        console.error('Error al obtener formularios:', error);
      }
    };

    // Obtener los tipos de observación desde la API
    const fetchPersonas = async () => {
      try {
        loadingPersonas.value = true;
        let response;
        response = await api.get(`api/Persona/ByRole`, {
          params:{
            role: form.value.Observacions.find(
                    obs => ['Profesor', 'Alumno', 'Familia'].includes(obs.TipoEvaluado)
                  )?.TipoEvaluado || null
          },
        });
        persona.value = response.data;
        console.log(persona.value)
        loadingPersonas.value = false;
      } catch (error) {
        loadingPersonas.value = false;
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    // Obtener los tipos de observación desde la API
    const fetchSubordinados = async (id) => {
      try {
        loadingPersonas.value = true;
        let response = await api.get(`api/Persona/Subordinados`, {
          params:{
            id: id
          },
        });

        form.value.Observacions.forEach(observacion => {
          if(!observacion.Oculta){
            observacion.Valores.forEach(valor => {
              const idEvaluador = valor.Submit.IdEvaluador;

              // Verifica cuántas veces aparece en la lista de personas
              const coincidencias = response.data.filter(persona => persona.IdPersona === idEvaluador);
              const cantRespuesta = form.value.Observacions
                .flatMap(obs => obs.Valores) // Aplanar todas las observaciones en un solo array de valores
                .filter(v => v.IdRespuesta === valor.IdValor).length;
                
              console.log(cantRespuesta);

              const fechaGMT3 = new Date(valor.Submit.FechaHora);

              // Ajusta la hora para que esté en GMT-3 (restando 3 horas)
              fechaGMT3.setHours(fechaGMT3.getHours() - 3);

              // Agrega cada coincidencia la cantidad de veces que aparece en Valores
              coincidencias.forEach(() => {
                  evaluados.value.push({
                    ...valor.Submit.IdEvaluadorNavigation,  // Copia la información de la persona
                    IdSubmit: valor.IdSubmit,
                    cantRespuesta: cantRespuesta,
                    fechaRegistro: fechaGMT3.toLocaleString('es-AR', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                        hourCycle: 'h23' // Usa el formato de 24 horas
                                      })
                  });
                });
            });
            // Detiene el recorrido de Observacions
            return true;
          }
        });

        console.log(evaluados.value)
        loadingPersonas.value = false;
      } catch (error) {
        loadingPersonas.value = false;
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    const fetchEvaluadores = async () => {
      try {
        loadingPersonas.value = true;

        // Llamar al nuevo endpoint para traer a todos los evaluadores
        let response = await api.get(`api/Persona/ByRole?role=Empleado`);

        // Vaciar evaluados antes de llenarlo
        evaluados.value = [];

        form.value.Observacions.forEach(observacion => {
          if (!observacion.Oculta) {
            observacion.Valores.forEach(valor => {
              if(valor.IdRespuesta == null){
                const idEvaluador = valor.Submit.IdEvaluador;

                // Verifica si el evaluador está en la lista de personas obtenidas
                const coincidencias = response.data.filter(persona => persona.IdPersona === idEvaluador);
                const cantRespuesta = form.value.Observacions
                  .flatMap(obs => obs.Valores) // Aplanar todas las observaciones en un solo array de valores
                  .filter(v => v.IdRespuesta === valor.IdValor).length;

                console.log(cantRespuesta);
                const fechaGMT3 = new Date(valor.Submit.FechaHora);

                // Ajusta la hora para que esté en GMT-3 (restando 3 horas)
                fechaGMT3.setHours(fechaGMT3.getHours() - 3);
                // Agrega cada coincidencia la cantidad de veces que aparece en Valores
                coincidencias.forEach(() => {
                  evaluados.value.push({
                    ...valor.Submit.IdEvaluadorNavigation,  // Copia la información de la persona
                    IdSubmit: valor.IdSubmit,
                    cantRespuesta: cantRespuesta,
                    fechaRegistro: fechaGMT3.toLocaleString('es-AR', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                        hourCycle: 'h23' // Usa el formato de 24 horas
                                      })
                  });
                });
              }
            });

            // Detiene el recorrido de Observacions
            return true;
          }
        });

        console.log('asdasd');
        console.log(evaluados.value);
        loadingPersonas.value = false;
      } catch (error) {
        loadingPersonas.value = false;
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    // Obtener las Asignaturas
    const fetchAsignaturas = async () => {
      try {
        loadingMaterias.value = true;
        const response = await api.get(`api/Asignaturas/ByIdProfesor`, {
          params:{
            id: selectedPersona.value
          },
        });
        if(response.status == 200){
          asignaturas.value = response.data;
        }
        else{
          asignaturas.value = [];
          console.error('Error al obtener los tipos de observación:');
        }
        console.log(asignaturas.value)
        loadingMaterias.value = false;
      } catch (error) {
        asignaturas.value = [];
        console.error('Error al obtener los tipos de observación:', error);
        console.log(asignaturas.value)
        loadingMaterias.value = false;
      }
    };
    
    // Obtener los Cursos o Grupos
    const fetchCursosGrupos = async () => {
      try {
        loadingCursosGrupos.value = true;
        const response = await api.get(`api/Asignaturas/CursosGrupos`);
        if(response.status == 200){
          cursosGrupos.value = response.data;
        }
        else{
          cursosGrupos.value = [];
          console.error('Error al obtener los tipos de observación:');
        }
        console.log(cursosGrupos.value)
        loadingCursosGrupos.value = false;
      } catch (error) {
        asignaturas.value = [];
        console.error('Error al obtener los tipos de observación:', error);
        console.log(asignaturas.value)
        loadingCursosGrupos.value = false;
      }
    };

    // Filtrar CursosGrupos basadas en el input de búsqueda
    const filterCursosGrupos = () => {
      if (!searchQueryCursosGrupos.value) {
        filteredCursosGrupos.value = [];
      } else {
        const query = searchQueryCursosGrupos.value.toLowerCase();
        filteredCursosGrupos.value = cursosGrupos.value.filter(evaluado =>
          `${evaluado.CursoGrupo}`.toLowerCase().includes(query)
        );
      }
    };
    const selectCursoGrupo = (evaluado) => {
      selectedCursosGrupos.value = evaluado.IdCursoGrupo;
      searchQueryCursosGrupos.value = `${evaluado.CursoGrupo}`;
      filteredCursosGrupos.value = []; // Limpia la lista filtrada
    };

    // Filtrar personas basadas en el input de búsqueda
    const filterPersonas = (observacion) => {
      if (!observacion.SearchQuery) {
        observacion.FilteredPersonas = [];
      } else {
        const query = observacion.SearchQuery.toLowerCase();
        observacion.FilteredPersonas = persona.value.filter(evaluado =>
          `${evaluado?.Apellido} ${evaluado?.Nombre}`.toLowerCase().includes(query)
        );
      }
    };
    const selectPersona = (evaluado, observacion) => {
      selectedPersona.value = evaluado.IdPersona; // Asigna la persona seleccionada
      if(observacion.ConEleccionMateria){
        fetchAsignaturas();
      }
      observacion.SearchQuery = `${evaluado?.Apellido} ${evaluado?.Nombre}`; // Muestra el nombre en el input
      observacion.FilteredPersonas = []; // Limpia la lista filtrada
    };

    const validateRanges = () => {
      for (let observacion of form.value.Observacions) {
        // Solo aplicamos la validación a las observaciones de tipo range
        if ((observacion.IdTipoObservacion === '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase())&&(observacion.Obligatorio)) {
          if (observacion.Valores[0].ValorObservado === null) {
            alert(t('seleccionarValorRango')+`: ${observacion.NombreObservacion}`);
            return false; // Si hay un campo no válido, detenemos el envío
          }
        }
      }
      return true; // Si todo está correcto, permitimos el envío
    };
    const addValor = () => {
      formRespuestas.value = structuredClone(form.value);
      for(let observacion of formRespuestas.value.Observacions){
        observacion.Valores = []; // Vacia los valores en caso de tener
        observacion.Valores.push({
          Submit: {
            IdEvaluador: null,
            IdEvaluado: null,
            IdAsignatura: null,
            IdCursoGrupo: null,
            FechaHora: null,
          },
          IdRespuesta: null,
          IdObservacion: observacion.IdObservacion, 
          ValorObservado: '',
          Comentario: '',
        });
        if(observacion.IdTipoObservacion == '0414BD8D-C03E-4D25-800B-88C603FEDC44'.toLowerCase()){ //Rango
          for(let item of observacion.ItemsObservacions){
            switch (item.NombreItem) {
              case 'Minimo':
                minRange.value = item.ValorDeRango
                break;
              case 'Maxima':
                maxRange.value = item.ValorDeRango
                break;
              case 'StepValue':
                stepValue.value = item.ValorDeRango
                break;
            }
          }
        }
      }
    };

    const submit = async () => {
      if (!validateRanges()) {
        return; // Detenemos el envío si la validación de rangos falla
      }
      try {
        // Asigna la versión limpia a form
        loadingSubmit.value = true;
        let valores = []
        for(let observacion of formRespuestas.value.Observacions){
          //Si la observacion NO es la de tipo Evaluado, se guarda el valor. El valor de una observacion de tipo Evaluado NO se guarda
          if(observacion.IdTipoObservacion != '989bec4b-779d-41b0-8b28-1f1487b59ded'){
            if(observacion.Archivo){
              const archivoData = new FormData();
              archivoData.append('archivo', observacion.Archivo); // Agrega el archivo con una clave 'archivo'

              const response2 = await api.post(`api/Archivos`, archivoData, {
                headers: {
                  'Content-Type': 'multipart/form-data', // Asegúrate de enviar el tipo de contenido correcto
                }
              });
              observacion.Valores[0].ValorObservado = response2.data.enlace
              observacion.Valores[0].Comentario = observacion.Archivo.name
            }
            console.log('qweqwqweqwe')
            console.log(observacion)
            var valor = observacion.Valores[0]
            valor.Submit.IdEvaluado = selectedPersona.value;
            if(!form.value.Anonimo){
              valor.Submit.IdEvaluador = user?.value.idPersona;
            }
            valor.IdRespuesta = form.value.Observacions.find(obs => obs.IdObservacion == observacion.IdObservacion).Valores[0].IdValor
            valor.Submit.IdAsignatura = selectedAsignaturaId.value;
            valor.Submit.IdCursoGrupo = selectedCursosGrupos.value;
            valores.push(valor);
          }
        }
        console.log(valores)
        const cleanValues = JSON.stringify(toRaw(valores), null, 2); 
        
        console.log(cleanValues)
        await api.post(`api/Valores`, cleanValues);
        await router.push({ path: '/messagebox', query: { message: t('formEnviadoExitosamente'), redirect: t(`/formularios/ver?idForm=${form.value.IdFormulario}`) } });
        loadingSubmit.value = false;
      } catch (error) {
        console.error('Error al obtener formularios:', error);
        loadingSubmit.value = false;
      }
    };

    const handleFileUpload = (event, index) => {
      const file = event.target.files[0];
      if (!file) return;

      // Validar el tamaño del archivo (máximo 50 MB)
      const maxFileSize = 50 * 1024 * 1024; // 50 MB en bytes
      if (file.size > maxFileSize) {
        alert(this.$t('archivoExcedeTamano'));
        event.target.value = ''; // Reinicia el input
        return;
      }

      // Almacenar el archivo en el modelo
      form.value.Observacions[index].Archivo = file;
    };

    const cancelForm = async() => {
      const accesoCompletador = form.value.AccesoFormularios.find(acceso => acceso.IdPersona === user?.value.idPersona && acceso.TipoPermiso == "Completador" );
      //Si es completador tiene que volver a la pagina de formularios
      if (accesoCompletador) {
        await router.push('/formularios');
      }//Si es Editor o Lector tiene que volver a la pagina de ver
      else{
        await router.push(`/formularios/ver?idForm=${form.value.IdFormulario}`);
      }
    };
    onBeforeMount(() => {
      checkAuth();
    });
    onMounted(async() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      await fetchForm();
      if(form.value.AQuienesResponden == "Subordinados"){
        fetchSubordinados(user?.value.idPersona);
      }
      else{
        fetchEvaluadores()
      }
      
      if (form.value.Observacions.some(obs => obs.TipoEvaluado === 'Profesor') || form.value.Observacions.some(obs => obs.TipoEvaluado === 'Alumno') || form.value.Observacions.some(obs => obs.TipoEvaluado === 'Familia')){
        fetchPersonas();
        form.value.Observacions.forEach(obs => {
          if (obs.TipoEvaluado === 'Profesor' || obs.TipoEvaluado === 'Alumno' || obs.TipoEvaluado === 'Familia') {
            //obs.FilteredPersonas = persona.value;
          }
        });
        console.log('asasd')
      }
      if(form.value.Observacions.some(obs => obs.TipoEvaluado == 'Curso o Grupo')){
        fetchCursosGrupos();
      }
      if(form.value.Observacions.some(obs => obs.TipoEvaluado == 'Personalizado')){
        const observacionPersonalizada = form.value.Observacions.find(obs => obs.TipoEvaluado == 'Personalizado');
        if (observacionPersonalizada) {
            persona.value = observacionPersonalizada.ItemsObservacions.map(item => item.IdPersonaNavigation);
        }
      }
    });

    return {
      form,
      submit,
      cancelForm,
      minRange,
      maxRange,
      stepValue,
      persona,
      selectedPersona,
      selectedAsignaturaId,
      filterPersonas,
      selectPersona,
      asignaturas,
      loadingMaterias,
      loadingCursosGrupos,
      loadingPersonas,
      loadingForm,
      loadingSubmit,
      t,
      cursosGrupos,
      searchQueryCursosGrupos,
      filteredCursosGrupos,
      selectedCursosGrupos,
      filterCursosGrupos,
      selectCursoGrupo,
      handleFileUpload,
      user,
      evaluados,
      searchQuery,
      filteredevaluados,
      selectedevaluados,
      ValorEvaluado,
      formValoresDeEvaluado,
      formRespuestas,
    };
  },
};
</script>

<style scoped>
  /* Estilo para el botón cuando está seleccionado */
  .btn-check:checked + label {
    background-color: var(--goethe-accent-claro-2); /* Cambia el color de fondo */
    color: var(--texto-principal); /* Cambia el color del texto */
    border-color: var(--goethe-accent-claro-2); /* Cambia el color del borde si lo deseas */
  }

  /* Estilo para el botón deseleccionado */
  .btn-check + label {
    background-color: transparent; /* Color de fondo por defecto */
    color: var(--texto-principal); /* Color del texto por defecto */
    border-color: var(--goethe-accent-claro-3); /* Color del borde por defecto */
  }
  /* Estilo para el hover */
  .btn-check + label:hover {
    background-color: var(--goethe-accent-claro-3); /* Cambia el color de fondo al hacer hover */
    cursor: pointer; /* Cambia el cursor al hacer hover */
  }
  /* Deshabilitar hover si está seleccionado */
  .btn-check:checked + label:hover {
    background-color: var(--goethe-accent-claro-2); /* Mantiene el color del botón si está seleccionado */
    color: var(--texto-principal); /* Mantiene el color del texto si está seleccionado */
  }

  .list-group {
    max-height: 200px; /* Ajusta según lo necesario */
    overflow-y: auto; /* Añade desplazamiento si es necesario */
  }

  .list-group-item {
    background-color: white; /* Color de fondo de los items */
  }

  .list-group-item:hover {
    background-color: #f8f9fa; /* Color al pasar el mouse */
  }
</style>
